module.exports = __webpack_public_path__ + "static/img/Testimonial.cd4b759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/Testimonial.png
// module id = fkqU
// module chunks = 36